<template lang="pug">
div
  AppDialog.time-off-request-dialog(
    v-show="showDialog"
    size="medium"
    position="centered"
    append-to-body
    has-footer
    :title="timeOffRequest.policyName"
    :show="show"
    @close="close()"
  )
    .information
      .avatar
        HubAvatar(
          :user-id="timeOffRequest.userId"
          :users-avatars="usersAvatars"
          avatar-style="thumb"
        )
        span.name {{ event.userRealName }}

      .text-right {{ event.range }}
        .text-gray {{ timeOffRequest.dateRange }}

    table.time-table
      tbody
        tr(v-if="timeOffRequest.allDay")
          td Time off used:
          td {{ timeOffRequest.timeUsed }} hrs
        tr
          td Total time span:
          td {{ timeOffRequest.totalTimeSpan }}

    .shift-overlap-warning(v-if="showShiftOverlapWarning")
      i.hi-important.icon
      p.text {{ timeOffRequest.shiftOverlapWarning }}

    template(#footer)
      .actions
        div
          AppButton(
            v-if="timeOffRequest.canDeny"
            type="danger"
            @click="denyRequest()"
          ) Deny
        div
          AppButton(
            v-if="timeOffRequest.canApprove"
            type="primary"
            @click="approveRequest()"
          ) Approve

  ShiftOverlapConfirmationDialog(
    v-if="showShiftOverlapConfirmationDialog"
    :time-off-request="timeOffRequest"
    @close="close()"
  )
</template>

<script>
import { applyTemplate } from '~/utils/url_template';
import { TIME_OFF_REQUEST_URL } from '~/app_constants';
import { mapInertiaProps } from '~/utils/inertia';
import { createUsersAvatarsMixin } from '~/mixins/UsersAvatarsMixin';
import ShiftOverlapConfirmationDialog from '~/components/attendance_schedules/dialogs/ShiftOverlapConfirmationDialog.vue';

export default {
  name: 'TimeOffRequestDialog',
  components: { ShiftOverlapConfirmationDialog },
  mixins: [createUsersAvatarsMixin('assignedMember')],
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    event: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showShiftOverlapConfirmationDialog: false,
    showDialog: true,
  }),
  computed: {
    ...mapInertiaProps({
      members: ({ calendar_resources: calendarResources }) => calendarResources.users,
    }),
    timeOffRequest() {
      return this.event.timeOffRequestAttributes;
    },
    assignedMember() {
      return this.members.filter((user) => this.timeOffRequest.userId);
    },
    hasShiftOverlap() {
      return this.timeOffRequest.shiftCount > 0;
    },
    showShiftOverlapWarning() {
      return this.hasShiftOverlap && this.timeOffRequest.status !== 'Approved';
    },
  },
  methods: {
    async denyRequest() {
      const deniedStatusId = this.timeOffRequest.statuses.find((status) => status.name === 'Denied').id;
      const data = {
        time_off_request: {
          status: deniedStatusId,
          response: 'Denied through the schedules calendar',
        },
      };

      await this.updateStatus(data);
    },
    async approveRequest() {
      if (this.hasShiftOverlap) {
        return this.openShiftOverlapConfirmationDialog();
      }

      const approvedStatusId = this.timeOffRequest.statuses.find((status) => status.name === 'Approved').id;
      const data = {
        time_off_request: {
          status: approvedStatusId,
          response: 'Approved through the schedules calendar',
        },
      };

      await this.updateStatus(data);
    },
    async updateStatus(data) {
      const url = applyTemplate(`${TIME_OFF_REQUEST_URL}/update_status`, {
        id: this.timeOffRequest.id,
      });
      const payload = { ...data, current_page_title: document.title, current_url: document.URL };

      await this.$inertia.post(url, payload, {
        onSuccess: () => {
          this.close();
        },
      });
    },
    openShiftOverlapConfirmationDialog() {
      this.showDialog = false;
      this.showShiftOverlapConfirmationDialog = true;
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
